export default {
  methods: {
    /**
     * 计算入住时长
     * @param {Date} startTime 
     * @param {Date} endTime 
     * @param {String, Number} orderType 
     * @returns {Number}
     */
    getDiffTime(startTime, endTime, orderType) {
      if (!startTime || !endTime) {
        return 0;
      }
      let start = new Date(startTime);
      let end = new Date(endTime);
      let stayTime = +end - +start;
      // 1：全日房；2：钟点房
      if (orderType == 1) {
        stayTime = Math.round(stayTime / (24 * 60 * 60 * 1000));
      }
      if (orderType == 2) {
        stayTime = Math.round(stayTime / (60 * 60 * 1000));
      }
      stayTime = stayTime < 1 ? 1 : stayTime;
      return stayTime;
    },
    /**
     * 获取房费
     * @param {Object} params
     * {
     *    endTime: '结束时间，日期String',
     *    hourNum: '小时数，Number',
     *    isHourRoom: '是否钟点房，Boolean',
     *    nightNum: '晚数，Number',
     *    roomTypeId: '房型ID',
     *    startTime: '开始时间，日期String'
     * }
     */
    getRoomPrice(params, cb) {
      let url = "ROOM.TYPE.GET_ROOM_PRICE";
      this.fetchData({
        url: url,
        method: "get",
        params,
        headers: { "Content-Type": "application/json" },
        flag: true,
      })
        .then((res) => {
          if (res.code == 200) {
            cb && cb(res.data);
          } else {
            this.$message.error(res.msg || "房费计算失败！");
          }
        })
        .catch((err) => {
          this.$message.error(err || "房费计算失败！");
        });
    },
    // 上传健康码
    uploadHealthCode(file) {
      let phoneNum = this.curUploadData.item.personPhone
      if (!phoneNum) {
        return this.$message.error('请补充手机号后再上传“健康码”')
      }
      let params = {
        file,
        phoneNum: this.curUploadData.item.personPhone
      }
      let url = 'ORDER.POST_HEALTH_CODE_UPLOAD'
      this.upload({ url, params }).then(res => {
        if (res.success) {
          this.$message.success('上传成功！')
          this.curUploadData.item.healthCode = res?.data
        } else {
          this.$message.error(res.info || '上传失败！')
        }
      }).catch(err => {
        this.$message.error(err || '上传失败！')
      })
    },
    // 上传约束
    beforeAvatarUpload(file) {
      let tailType = file.name.slice(file.name.lastIndexOf(".") + 1);
      let isType = ["jpeg", "jpg", "png"].indexOf(tailType.toLowerCase()) > -1;
      if (!isType) {
        this.$message.error("只能上传jpeg/jpg/png文件");
        return false;
      }

      const isLtM = file.size / 1024 / 1024 <= 4;
      if (!isLtM) {
        this.$message.error("上传附件大小不能超过 4MB!");
        return false;
      }

      if (this.curUploadData.type === 'health') {
        this.uploadHealthCode(file)
        return false
      }
      
      return true
    },
    // 处理上传失败
    handleUploadFail(e) {
      console.log(e, '================ fail');
    },
    // 处理上传成功
    handleUploadSuccess(res, file) {
      if (this.curUploadData.type === 'trip') {
        this.curUploadData.item.tripCode = res?.data
      } else {
        this.curUploadData.item.healthCode = res?.data
      }
    },
    handleUploadRemove() {},
  },
};
